const $detailMap = $('#ttgDetailKarte');

$(document).ready(function() {

    if ($(".ttg-detail-map").length) {

        (async () => {

            _ttgMaps.mapOptions.experience = $detailMap.data('mapsconfig');
            _ttgMaps.metaParams.experience = _ttgMaps.mapOptions.experience;

            // falls noch kein Key: einmalig vom Server holen
            await _ttgMaps.f.getLicenseKey();
            _ttgMaps.mapOptions.licenseKey = _ttgMaps.metaParams.licensekey;

            _ttgMaps.f.loading($detailMap);

            _ttgMaps.mapOptions.container = "ttgDetailKarte";
            _ttgMaps.mapOptions.center = {
                lng: parseFloat($detailMap.data('lon')),
                lat: parseFloat($detailMap.data('lat'))
            };
            _ttgMaps.mapOptions.zoom = 12;
            _ttgMaps.metaParams.mkt = _ttgMaps.lang;

            if ($('#' + _ttgMaps.mapOptions.container).data('mapslicense') != 1) {
                _ttgMaps.mapOptions.navigationControl = false;
                _ttgMaps.mapOptions.geolocateControl = false;
                _ttgMaps.mapOptions.styleControl = false;
                _ttgMaps.mapOptions.fullscreenControl = false;
            }

            console.log("METAPARAMS");
            console.log(_ttgMaps.metaParams);

            if (Done.Maps.isSupported()) {
                ttgMaps[0] = Done.Maps.newMap(_ttgMaps.mapOptions);
                ttgMaps[0].on('load', _ttgMaps.f.detailMap.loadDetailMap);
            }
        })();
    }

});

_ttgMaps.f.detailMap = {

    loadDetailMap: function() {

        ttgMaps[0].map.setPitch(_ttgMaps.mapOptions.pitch);
        // ttgMaps[0].setMapStyle('Topo');

        if ($detailMap.data('metasourcecategory') === 'Tour') {

            // WENN TOUR
            setTimeout(function() {

                _ttgMaps.f.showTourAndElevationChart({
                    global_id: 'tourdata_tour_' + $detailMap.data('sourceid')
                });

                // DRAW START POINT (grüner Pin)
                _ttgMaps.activePin = ttgMaps[0].addMarker({
                    lat: _ttgMaps.mapOptions.center.lat,
                    lng: _ttgMaps.mapOptions.center.lng,
                    color: _ttgMaps.pinColors.startOfTour
                });

                // SET ACTIVE PIN ClASS > für Symbol Darstellung und Umrandung
                if ($(_ttgMaps.activePin._element).find('span').length === 0) {
                    $(_ttgMaps.activePin._element)
                        .addClass('ttgMaps_activePin')
                        .append(
                            $('<span />').addClass('ttgMaps_pinSymbol').html('<i class="fa-fw ' + _ttgMaps.mapOptions.markerTypes[$detailMap.data('metasourcecategory').toLowerCase()] + '"></i>')
                        );
                }

                // DRAW END POINT bzw. CHECK RUNDWEG
                _ttgMaps.f.detailMap.tourpins();

            }, 500);

        } else {

            // WENN NICHT TOUR
            _ttgMaps.activePin = ttgMaps[0].addMarker({
                lat: _ttgMaps.mapOptions.center.lat,
                lng: _ttgMaps.mapOptions.center.lng,
                color: _ttgMaps.pinColors.selected
            });

            // SET ACTIVE PIN ClASS > für Symbol Darstellung und Umrandung
            if ($(_ttgMaps.activePin._element).find('span').length === 0) {
                $(_ttgMaps.activePin._element)
                    .addClass('ttgMaps_activePin')
                    .append(
                        $('<span />').addClass('ttgMaps_pinSymbol').html('<i class="fa-fw ' + _ttgMaps.mapOptions.markerTypes[$detailMap.data('metasourcecategory').toLowerCase()] + '"></i>')
                    );
            }

        }

        // DRAW ENTRY INFO
        let $entryInfo = $('<div />').addClass('selectedMapItemInfo'),
            $title = $('<div />').addClass('entryTitle').text($('.ttgTourdataDetailseiteTitelOrtContainer h1').text());

        $title.appendTo($entryInfo);
        $entryInfo.prependTo($('#ttgFullScreenSelectedMapItem'));

        // FULLSCREEN
        window.addEventListener('fullscreenchange', () => {

            if (document.fullscreen) {
                // FULLSCREEN

                // Umkreissuche
                _ttgMaps.f.detailMap.fancyUmkreis(true);

                // Wegpunkte & Relationen laden und anzeigen
                _ttgMaps.f.detailMap.showWegpunkte();
                _ttgMaps.f.detailMap.showRelations();

            } else {

                // NO FULLSCREEN = keine Relationen anzeigen/Relationen Layer löschen
                ttgMaps[0].clearMetaLayer();
                ttgMaps[0].hidePopup();
                if ($detailMap.data('metasourcecategory') != 'Tour') {
                    ttgMaps[0].clearTour();
                }
                _ttgMaps.f.detailMap.fancyUmkreis(false);
                _ttgMaps.f.detailMap.removeWegpunkte();

            }

        });

        // SELECTED MAP ITEM ACTION
        ttgMaps[0].on('item-selected', (ev) => {

            // Lade Item via Schnittstelle
            const item = _ttgMaps.f.getMapItem(ev.item.item);
            item.then(
                response => {
                    _ttgMaps.f.detailMap.generatePopup(response.items[0]);

                    if (response.items[0].type === 'Tour' && $detailMap.data('metasourcecategory') != 'Tour') {

                        // Tour anzeigen, aber Zoomlevel beibehalten >> nur wenn der Haupteintrag nicht schon eine Tour ist
                        const currentZoom = ttgMaps[0].map.getZoom();
                        _ttgMaps.f.detailMap.showLinkedTour(response.items[0].id).then(function() {
                            ttgMaps[0].map.setZoom(currentZoom);
                        });

                    }

                }
            );

        });

        // Öffne Fullscreen bei Klick auf Karte
        $('body').on('click', '#ttgDetailKarte', function() {
            if (!$('body').hasClass('mapFullScreen') && $('#' + _ttgMaps.mapOptions.container).data('mapslicense') >= 1) {
                ttgMaps[0].setFullscreen(true);
            }
        });

        _ttgMaps.f.loading($detailMap, 'remove');

        // beim Terminal die Outgoing Links deaktivieren
        _ttgMaps.f.deactiveOutgoingLinks();

    },

    showLinkedTour: async function(id) {

        await _ttgMaps.f.getLicenseKey();
        _ttgMaps.mapOptions.licenseKey = _ttgMaps.metaParams.licensekey;

        let linkedTour = ttgMaps[0].showTour('tourdata_tour_' + id);
        return linkedTour;

    },

    tourpins: function() {

        setTimeout(function() {

            const lastPoint = ttgMaps[0].currentTour.points[ttgMaps[0].currentTour.points.length - 1];
            if (_ttgMaps.f.detailMap.checkRundweg(_ttgMaps.mapOptions.center, lastPoint)) {

                // Wenn Rundweg, nutze Rundweg Symbol im grünen Pin
                $(_ttgMaps.activePin._element)
                    .find('.ttgMaps_pinSymbol')
                    .html('<i class="fa-fw ' + _ttgMaps.mapOptions.markerTypes.tourspecial.rundweg + '"></i>');

            } else {

                // Wenn kein Rundweg nutze Play Symbol im grünen Pin
                $(_ttgMaps.activePin._element)
                    .find('.ttgMaps_pinSymbol')
                    .html('<i class="fa-fw ' + _ttgMaps.mapOptions.markerTypes.tourspecial.start + '"></i>');

                // DRAW END POINT
                _ttgMaps.endOfTour = ttgMaps[0].addMarker({
                    lat: lastPoint.lat,
                    lng: lastPoint.lng,
                    color: _ttgMaps.pinColors.endOfTour
                });
                if ($(_ttgMaps.endOfTour._element).find('span').length === 0) {
                    $(_ttgMaps.endOfTour._element)
                        .addClass('ttgMaps_activePin')
                        .append(
                            $('<span />').addClass('ttgMaps_pinSymbol').html('<i class="fa-fw ' + _ttgMaps.mapOptions.markerTypes.tourspecial.end + '"></i>')
                        );
                }

            }

        }, 500);

    },

    checkRundweg: function(firstPoint, lastPoint) {

        // FIRST & LAST POINT DIFFERENCE
        const latDistance = Math.abs(firstPoint.lat - lastPoint.lat),
            lngDistance = Math.abs(firstPoint.lng - lastPoint.lng);

        // FIRST & LAST POINT DIFFERENCE < 0.015 = RUNDWEG
        if (latDistance < 0.015 & lngDistance < 0.015) {
            return true;
        } else {
            return false;
        }

    },

    showRelations: function() {

        //console.log(_ttgMaps.f.detailMap.getRelationsReturnQString());
        ttgMaps[0].showContent({

            experience: $detailMap.data('mapsconfig'),
            mkt: _ttgMaps.lang,
            type: "All",
            q: _ttgMaps.f.detailMap.getRelationsReturnQString()
            // template: 'ET2014A.json' // wird nicht berücksichtigt, keine Ahnung warum

        });

    },

    getRelationsReturnQString: function() {
        // Alle Relationen des Items aus Data-Attribut "relations" holen & für META-Query aufarbeiten

        let relations = $detailMap.data('relations').split('-');
        let grouped = {};

        // Nach Typ gruppieren + Duplikate vermeiden
        $.each(relations, function(i, rel) {
            let parts = rel.split(':');
            let type = parts[0];
            let id = parts[1];

            if (!grouped[type]) {
                grouped[type] = new Set();
            }

            grouped[type].add(id);
        });

        let queryParts = [];

        $.each(grouped, function(type, ids) {
            let idString = Array.from(ids).join(' OR ');
            queryParts.push('(type:' + type + ' sourceid:(' + idString + '))');
        });

        return '(' + queryParts.join(' OR ') + ')';
    },

    showWegpunkte: function() {

        if (ttgWegpunkte.length > 0) {
            ttgMaps[0].wegpunkte = [];

            $.each(ttgWegpunkte, function(i, wp) {
                ttgMaps[0].wegpunkte[i] = ttgMaps[0].addMarker({
                    lat: wp.lat.replace(',', '.'),
                    lng: wp.lon.replace(',', '.'),
                    id: wp.id,
                    color: _ttgMaps.pinColors.wegpunkte
                });

                let bezeichnung = (wp.bezeichnung) ? '<div class="bezeichnung">' + wp.bezeichnung + '</div>' : '',
                    img = (wp.img) ? '<div class="img"><img src="' + wp.img + '" /></div>' : '',
                    rawText = wp.text ? wp.text.replace(/&lt;br\s*\/?&gt;/gi, ' ').replace(/<br\s*\/?>/gi, ' ') : '',
                    text = rawText ? '<div class="text">' + rawText + '</div>' : '';

                let $marker = $(ttgMaps[0].wegpunkte[i]._element);
                $marker.addClass('wegpunkt').append(
                    '<div class="wegpunktContent">' + bezeichnung + img + text + '</div>'
                );

                if (rawText) {
                    $marker.find('.wegpunktContent .text').Cuttr({
                        licenseKey: cuttrLicenseKey,
                        truncate: 'words',
                        length: 50,
                        ending: '...',
                        readMore: false
                    });
                }
            });
        }

    },

    removeWegpunkte: function() {

        if (ttgMaps[0].wegpunkte.length > 0) {
            $.each(ttgMaps[0].wegpunkte, function(i, wp) {
                wp._element.remove();
            });
            delete ttgMaps[0].wegpunkte;
        }

    },

    generatePopup: function(item) {
        // Erstelle Popup mit Inhalt aus item

        let popup = ttgMaps[0].createPopup(item),
            $popupContent = $('<div />'),
            $container = $('<div />').addClass('container-fluid').css({ 'padding': '5px 10px', 'position': 'relative' }),
            $row = $('<div />').addClass('row'),
            oesPos = item.web.search('/oesterreich-'),
            relUrl = item.web.slice(oesPos);

        // Row 1 = Titel
        let $row1 = $row.clone().addClass('row1'),
            $title = $('<div />').addClass('title').html('<div class="col-xs-12"><b>' + item.title + '</b></div>');
        $row1.append($title);

        // Row 2 = Bild & Teaser
        let $row2 = $row.clone().addClass('row2').css({ 'margin-top': '15px', 'margin-bottom': '15px' }),
            $col1 = $('<div />').addClass('col-xs-4'),
            $col2 = $('<div />').addClass('col-xs-8');

        // Bild
        let src = '';
        $.each(item.media_objects, function(i, media) {
            if (media.rel === 'default') {
                src = media.url;
            }
        });
        $col1.append('<a href="' + relUrl + '" target="_blank"><img src="' + src + '" class="img-fluid" /></a>');

        // Teaser
        let teaser = '';
        $.each(item.texts, function(i, text) {
            if (text.rel === 'teaser') {
                teaser = text.value;
            }
        });
        $col2.html(teaser);
        $row2.append($col1).append($col2);

        // Row 3 = Verlinkung
        let $row3 = $row.clone().addClass('row3');
        $row3.html('<div class="col-xs-12 text-right">&raquo; <a href="' + relUrl + '" target="_blank" class="ml-2" style="color: #fff; text-decoration: underline;">Details</a></div>');

        $container.append($row1).append($row2).append($row3).append('<a href="javascript:ttgMaps[0].hidePopup();" style="position: absolute; top: 0; right: 0; color: #fff; font-size: 18px;"><i class="fas fa-times"></i></a>');
        $popupContent.append($container);
        popup.getHTML = () => $popupContent.html();
        ttgMaps[0].showPopup(popup);
        ttgMaps[0].flyTo({
            center: [popup.position.lng, popup.position.lat]
        });

    },

    fancyUmkreis: function(enable) {

        if (enable) {

            let $fU = $('<div />').prop('id', 'fancyUmkreis');

            $fU.html('<div class="headline">Finde Interessantes im Umkreis</div>');

            let $form = $('<div />').addClass('form'),
                $opt = $('<div />').addClass('opt mt-3 mb-3'),
                $gastronomie = $('<label />').addClass('checkbox-inline gastro').html('<input type="checkbox" id="inlineCheckbox1" value="Gastro"><span class="fas fa-utensils" aria-hidden="true"></span><span class="text">Gastronomie</span>').prop('title', 'Gastronomie'),
                $unterkuenfte = $('<label />').addClass('checkbox-inline unterkuenfte').html('<input type="checkbox" id="inlineCheckbox2" value="Hotel"><span class="fas fa-bed" aria-hidden="true"></span><span class="text">Unterkünfte</span>').prop('title', 'Unterkünfte'),
                $pois = $('<label />').addClass('checkbox-inline pois').html('<input type="checkbox" id="inlineCheckbox3" value="POI"><span class="fas fa-bullseye" aria-hidden="true"></span><span class="text">Sehenswertes</span>').prop('title', 'Sehenswertes'),
                $touren = $('<label />').addClass('checkbox-inline touren').html('<input type="checkbox" id="inlineCheckbox4" value="Tour"><span class="fas fa-flag" aria-hidden="true"></span><span class="text">Sehenswertes</span>').prop('title', 'Touren'),
                $events = $('<label />').addClass('checkbox-inline events').html('<input type="checkbox" id="inlineCheckbox5" value="Event"><span class="fas fa-calendar-alt" aria-hidden="true"></span><span class="text">Sehenswertes</span>').prop('title', 'Veranstaltungen'),
                $range = $('<div />').addClass('form-group').html('<label for="formControlRange" class="rangeLabel">Im Umkreis von <b>5 km</b> anzeigen</label><input type="range" class="custom-range" id="formControlRange" min="0.5" max="10" step="0.5" value="5">'),
                $info = $('<div />').addClass('info').html('<b>Aktuell angezeigt:</b> <br /><ul><li class="entry">' + $('#ttgFullScreenSelectedMapItem .entryTitle').text() + '</li><li class="relations">Empfehlungen</li><li class="types"></li></ul>');
            // $button = $('<button />').addClass('btn btn-default mt-3').text('Im Umkreis von 10km anzeigen');

            $opt
                .append($gastronomie)
                .append($unterkuenfte)
                .append($pois)
                .append($touren)
                .append($events);

            $form
                .append($opt)
                // .append($button)
                .append($range)
                .append($info)
                .appendTo($fU);

            $form.on('change', 'input', function() {
                _ttgMaps.f.detailMap.getUmkreis($form);
            });

            $fU.appendTo($('#ttgDetailKarte'));

        } else {

            $('#fancyUmkreis').remove();

        }

    },

    getUmkreis: function($form) {

        const rangeVal = $form.find('.custom-range').val();
        $form.find('.rangeLabel b').text(rangeVal.toString().replace(".", ",") + ' km');

        let qString = '',
            typeString = '';
        $.each($form.find('input:checked'), function(i, input) {

            if ($(input).prop('checked')) {
                if (i === 0) {
                    qString += 'type:(' + $(input).val();
                    typeString += $(input).closest('label').prop('title');
                } else {
                    qString += ' || ' + $(input).val();
                    typeString += ', ' + $(input).closest('label').prop('title');
                }
            }

        });
        qString += (qString !== '') ? ')' : '';

        if (qString !== '') {

            // Lade Inhalte im Umkreis, wenn irgendein Typ ausgewählt wurde
            const range = rangeVal * 1000,
                nearhashlink = ' (nearhashlink:"~' + range + 'm tourdata_' + $detailMap.data('metasourcecategory').toLowerCase() + '_' + $detailMap.data('sourceid') + '")';

            $.ajax({
                type: "POST",
                url: window.location.protocol + "//" + window.location.host + "/?type=2090",
                data: {
                    experience: _ttgMaps.metaParams.experience,
                    mkt: _ttgMaps.lang,
                    q: qString + nearhashlink,
                    template: 'ET2014A.json'
                },
                dataType: "jsonp"
            }).then(
                response => {
                    ttgMaps[0].showContent(response);
                }
            );

            $('#fancyUmkreis').addClass('typeSelected').find('.info .types').text(typeString);

        } else {

            // Wwenn Nichts ausgewählt wurde, Relationen via META Query laden und anzeigen, falls vorhanden
            _ttgMaps.f.detailMap.showRelations();
            $('#fancyUmkreis').removeClass('typeSelected').find('.info .typs').text('');

        }

    }

};
